"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElasticDataType = exports.ElasticDocumentType = void 0;
var ElasticDocumentType;
(function (ElasticDocumentType) {
    ElasticDocumentType["Callout"] = "callout";
    ElasticDocumentType["Product"] = "product";
})(ElasticDocumentType = exports.ElasticDocumentType || (exports.ElasticDocumentType = {}));
var ElasticDataType;
(function (ElasticDataType) {
    ElasticDataType["Text"] = "text";
    ElasticDataType["Long"] = "long";
    ElasticDataType["Date"] = "date";
    ElasticDataType["Float"] = "float";
    ElasticDataType["Nested"] = "nested";
    ElasticDataType["Keyword"] = "keyword";
    ElasticDataType["Boolean"] = "boolean";
})(ElasticDataType = exports.ElasticDataType || (exports.ElasticDataType = {}));
//# sourceMappingURL=elastic.js.map